<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pa-0">
        <TicketHeader :ticket="ticket" />
      </v-col>

      <v-col cols="12" class="mt-1 pa-0">
        <TicketWorkflow :ticket="ticket" />
      </v-col>

      <v-col
        v-if="ticket.data && ticket.data.refill"
        cols="12"
        md="6"
        class="mt-1 pa-0 pr-1"
      >
        <Refill :ticket="ticket" />
      </v-col>
      <v-col
        cols="12"
        :md="ticket.data && ticket.data.refill ? 6 : 12"
        class="mt-1 pa-0"
      >
        <v-card>
          <v-card-title class="pb-1 text-subtitle-1">
            <v-icon class="mr-1" small>mdi-text-long</v-icon>
            Beschreibung
          </v-card-title>
          <v-card-text>
            <v-textarea
              v-model="local_text"
              placeholder="Beschreibung / Kontext zum Ticket"
              outlined
              dense
              hide-details
              rows="4"
              auto-grow
              @blur="updateText"
            />
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="mt-1 pa-0">
        <TicketChat :ticket="ticket" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TicketHeader from "./TicketHeader"
import TicketWorkflow from "./ticket/TicketWorkflow"
import TicketChat from "./ticket/TicketChat"
import Refill from "./ticket/Refill"

export default {
  name: "Ticket",
  components: { Refill, TicketHeader, TicketWorkflow, TicketChat },
  props: ["ticket"],
  data() {
    return {
      local_text: this.ticket.text || "",
    }
  },
  watch: {
    "ticket.id"() {
      this.local_text = this.ticket.text || ""
    },
    "ticket.text"(v) {
      if (document.activeElement && document.activeElement.tagName === "TEXTAREA") return
      this.local_text = v || ""
    },
  },
  methods: {
    updateText() {
      if ((this.local_text || "") === (this.ticket.text || "")) return
      this.$store.dispatch("update", {
        payload_type: "PATCH",
        context: `/tickets/${this.ticket.id}`,
        payload: { text: this.local_text },
      })
    },
  },
}
</script>
